import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'

export const CredentialingFeature = {
  // Roles that are eligible for the Certificates feature
  Roles: [MccsRoles.CREDENTIALING_ADMIN, MccsRoles.CREDENTIALING],

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(CredentialingFeature.Roles, user),
} satisfies Feature
